export const savedToken = { value: "" };